<template>
  <div class="floating-input-label">
    <input
      ref="field"
      :id="id"
      :name="name"
      :required="required"
      :value="value"
      :pattern="pattern"
      :class="['floating-input-label__input', { 'user-error': showErrors && invalid }]"
      :disabled="disabled"
      type="text"
      placeholder=" "
      maxlength="255"
      @change="triggerChange"
    >
    <label
      class="floating-input-label__label"
      :for="id"
      v-text="label"
    ></label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    value: String,
    pattern: String,
    showErrors: Boolean,
    invalid: Boolean,
    disabled: Boolean,
    required: Boolean,
  },
  computed: {
    id() {
      // eslint-disable-next-line no-underscore-dangle
      return `${this._uid}-${this.name}`;
    },
  },
  methods: {
    triggerChange(event) {
      this.$emit('change', {
        name: this.name,
        value: event.target.value,
        invalid: !event.target.validity.valid,
      });
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$nextTick(() => {
          // after the text input field was updated emit a change to revalidate
          this.$emit('change', {
            name: this.name,
            value: this.$refs.field.value,
            invalid: !this.$refs.field.validity.valid,
          });
        });
      }
    },
    pattern(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$nextTick(() => {
          // trigger revalidation when pattern changed
          this.$emit('change', {
            name: this.name,
            value: this.$refs.field.value,
            invalid: !this.$refs.field.validity.valid,
          });
        });
      }
    },
  },
  mounted() {
    // set the validity state initially
    this.$emit('change', {
      name: this.name,
      value: this.$refs.field.value,
      invalid: !this.$refs.field.validity.valid,
    });
  },
  name: 'AwardCheckoutFormInputText',
};
</script>
